var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-company-container container"},[_c('about-title',{attrs:{"title":_vm.pageTitle}}),_c('div',{staticClass:"subtitle"},[_c('h3',[_vm._v(_vm._s(_vm.subtitle))])]),_c('about-content',{attrs:{"content":_vm.pageDescription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }